interface ViewToggleProps {
  currentView: 'git' | 'split' | 'unified';
  onViewChange: (view: 'git' | 'split' | 'unified') => void;
}

const ViewToggle = ({}: ViewToggleProps) => {
  return (
    <div className='flex items-center gap-2'>
      {/* <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <Button
              variant='ghost'
              size='sm'
              className='text-xs px-2'
              onClick={() => onViewChange('git')}
              data-active={currentView === 'git'}
            >
              <GitCompare className='w-4 h-4 mr-1' />
              {t('gitStyle.title')}
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t('gitStyle.tooltip')}</TooltipContent>
        </Tooltip>
      </TooltipProvider> */}

      {/* <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <Button
              variant='ghost'
              size='sm'
              className='text-xs px-2'
              onClick={() => onViewChange('split')}
              data-active={currentView === 'split'}
            >
              <GitBranch className='w-4 h-4 mr-1' />
              {t('splitStyle.title')}
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t('splitStyle.tooltip')}</TooltipContent>
        </Tooltip>
      </TooltipProvider> */}

      {/* <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <Button
              variant='ghost'
              size='sm'
              className='text-xs px-2'
              onClick={() => onViewChange('unified')}
              data-active={currentView === 'unified'}
            >
              <Eye className='w-4 h-4 mr-1' />
              {t('unifiedStyle.title')}
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t('unifiedStyle.tooltip')}</TooltipContent>
        </Tooltip>
      </TooltipProvider> */}
    </div>
  );
};

export default ViewToggle;
